import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const PaymentStatusChecker = () => {
  const [status, setStatus] = useState("Checking...");
  const [loading, setLoading] = useState(true);
  const { orderId } = useParams(); // Get orderId from URL path
  const navigate = useNavigate();

  useEffect(() => {
    if (!orderId) {
      setStatus("Invalid Order ID");
      setLoading(false);
      return;
    }
    pollPaymentStatus(orderId);
  }, [orderId]);

  const getPaymentStatus = async (orderId) => {
    const username = "RMWBWl0";
    const password = "3c42a596cd044fed81b492e74da4ae30";
    const encodedCredentials = btoa(`${username}:${password}`);
    const merchantAccountNumber = "2020892";
    
    const url = `https://rmsc.hubtel.com/v1/merchantaccount/merchants/${merchantAccountNumber}/transactions/status?clientReference=${orderId}`;

    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          Authorization: `Basic ${encodedCredentials}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to fetch payment status");
      }

      const result = await response.json();
      return result.data?.status || "Error";
    } catch (error) {
      console.error("Error fetching payment status:", error);
      return "Error";
    }
  };

  const pollPaymentStatus = async (orderId) => {
    let attempts = 0;
    const maxAttempts = 10;
    const pollingInterval = 5000;

    const returnUrl = `https://frankotrading.com/order-success/${orderId}`;
    const cancelUrl = "https://frankotrading.com/order-cancelled";

    const interval = setInterval(async () => {
      attempts++;
      const paymentStatus = await getPaymentStatus(orderId);

      if (paymentStatus === "Paid") {
        clearInterval(interval);
        setStatus("Payment Successful! Redirecting...");
        setLoading(false);
        setTimeout(() => navigate(returnUrl), 2000);
      } else if (paymentStatus === "Error" || attempts >= maxAttempts) {
        clearInterval(interval);
        setStatus("Payment Failed. Redirecting...");
        setLoading(false);
        setTimeout(() => navigate(cancelUrl), 2000);
      }
    }, pollingInterval);
  };

  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-gray-100">
      <div className="p-6 bg-white shadow-lg rounded-lg">
        <h2 className="text-xl font-semibold mb-4">Payment Status</h2>
        <p className="text-gray-600">{loading ? "Checking payment status..." : status}</p>
      </div>
    </div>
  );
};

export default PaymentStatusChecker;
